import React from 'react';

const Announcements = React.lazy(() =>
  import(
    /* webpackChunkName: "announcements" */ '../pages/master/Announcements'
  )
);

const CreateAnnouncement = React.lazy(() =>
  import(
    /* webpackChunkName: "create-new-announcement" */ '../pages/master/CreateAnnouncement'
  )
);

const JobsTelegram = React.lazy(() =>
  import(/* webpackChunkName: "jobs-telegram" */ '../pages/master/Jobs')
);

export default [
  {
    id: 'in-app-announcements',
    path: '/announcements/in-app-announcements',
    name: 'In-app Announcement',
    component: Announcements,
    exact: true,
  },
  {
    id: 'in-app-announcement-edit',
    path: '/announcements/in-app-announcements/:id',
    name: 'In-app Announcement Edit',
    component: CreateAnnouncement,
    excludeFromSidebar: true,
  },
  {
    id: 'telegram-alerts',
    path: '/announcements/telegram-alerts',
    name: 'Telegram Alerts',
    component: JobsTelegram,
  },
  {
    id: 'in-app-create-new-announcement',
    path: '/create/in-app-announcements',
    name: 'Create New Announcement',
    component: CreateAnnouncement,
    exact: true,
  },
];
